export { default as OrdenCompraGrid } from './Listar';
export { default as OrdenCompraCrear } from './Crear';
export { default as DetalleOrdenCompra } from './detalle';
export { default as IngresoMateria } from './Ingreso';
